/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CallStatus = {
    calling: 'calling',
    incoming: 'incoming',
    waiting: 'waiting',
    ringing: 'ringing',
    talking: 'talking',
    finished: 'finished'
} as const;
export type CallStatus = typeof CallStatus[keyof typeof CallStatus];

